export interface BundleSchedule {
  id: number;
  amount: number;
  currencyCode: string;
  bundleName: string;
}
